import {
  getTopicList,
  createTopics,
  editTopics,
  getOneTopic,
  deleteTopic,
  exportTopic,
  importTopic
} from "./../api.js";
export const state = {
  topicListRes: {},
  topicOneItemRes: {},
  createTopicRes: {},
  editTopicRes: {},
  deleteTopicRes: '',
  pagination: {}
};

export const getters = {
  editTopicRes: state => (state.editTopicRes ? state.editTopicRes : {}),
  deleteTopicRes: state => state.deleteTopicRes ? state.deleteTopicRes : [],
  createTopicRes: state => (state.createTopicRes ? state.createTopicRes : {}),
  topicListRes: state =>
    state.topicListRes ? state.topicListRes.data.data : {},
  topicOneItemRes: state =>
    state.topicOneItemRes ? state.topicOneItemRes.data : {},
  pagination: state => (state.topicListRes ? state.topicListRes.data : {})
};

export const mutations = {
  getTopic(state, data) {
    state.topicListRes = data;
  },
  getOneTopicMuta(state, data) {
    state.topicOneItemRes = data;
  },
  createTopics(state, data) {
    if (!data.error) {
      state.createTopicRes = data;
    } else {
      state.createTopicRes = data.error.response.data;
    }
  },
  editTopic(state, data) {
    if (!data.error) {
      state.editTopicRes = data;
    } else {
      state.editTopicRes = data.error.response.data;
    }
  },
  deleteTopic(state, data) {
    if (!data.error) {
      state.deleteTopicRes = data;
    } else {

      state.deleteTopicRes = data.error.response.data;
    }
  }
};

export const actions = {
  async getTopicTest({ commit }, query) {
    let data = await getTopicList(query);
    commit("getTopic", data);
  },
  async createTopic({ commit }, params) {
    let data = await createTopics(params);
    commit("createTopics", data);
  },
  async editTopic({ commit }, params) {
    let data = await editTopics(params);
    commit("editTopic", data);
  },
  async getOneTopicTest({ commit }, params) {
    let data = await getOneTopic(params);
    commit("getOneTopicMuta", data);
  },
  async deleteTopicAction({ commit }, params) {
      let isSuccess = await deleteTopic(params);
    //let data = await getTopicList();
      commit("deleteTopic", isSuccess);
  },
  async importTopic({ commit }, params) {
    let isSuccess = await importTopic(params);
    // lay ma code tra ve
    commit("createTopics", isSuccess);
  },
  async exportTopic({ commit }, params) {
    let isSuccess = await exportTopic(params);
    commit("createTopics", isSuccess);
  }
};
